export default __webpack_public_path__ + "static/media/p31.936c2c5d.JPG";